import classNames from '../../../bpmn.io/classnames';
import {
    Errors,
    FormContext,
    Numberfield,
    Description,
    Label,
    
  } from '../../../bpmn.io/@bpmn-io/form-js';

import {
  useContext,
  useState
} from 'preact/hooks';

import {
  html
} from 'htm/preact';


import { AppData } from "../../helpers/app-data";

// ── Helpers de chunked upload ─────────────────────────────────────────────────

function _buildApiHeaders() {
  const token = sessionStorage.getItem(AppData.localStorageToken);
  return {
    'Authorization': `Bearer ${token}`,
    'X-APIKey': AppData.API_KEY,
  };
}

function _sanitizeForIdSesion(name) {
  // Solo letras, números, puntos, guiones y guiones bajos (requerido por el backend)
  return name.replace(/[^a-zA-Z0-9._-]/g, '_');
}

async function _uploadChunked(file, onProgress) {
  const CHUNK_SIZE = (AppData.CHUNK_SIZE_MB || 5) * 1024 * 1024;
  const totalPartes = Math.ceil(file.size / CHUNK_SIZE);

  // IdSesion único: {nombreBase}__{timestamp}.{ext} — la extensión SIEMPRE al final
  const _ext = file.name.includes('.') ? file.name.substring(file.name.lastIndexOf('.')) : '';
  const _base = _sanitizeForIdSesion(file.name.substring(0, file.name.lastIndexOf('.') >= 0 ? file.name.lastIndexOf('.') : file.name.length));
  const idSesion = `${_base}__${Date.now()}${_ext}`;

  let finalResult = null;

  for (let i = 0; i < totalPartes; i++) {
    const numeroParte = i + 1; // 1-based
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunkBlob = file.slice(start, end);

    // El nombre del chunk codifica toda la info que el backend necesita
    const chunkFileName = `${idSesion}.part_${numeroParte}_${totalPartes}`;

    const formData = new FormData();
    formData.append('Chunk', chunkBlob, chunkFileName);

    let subido = false;
    for (let intento = 0; intento < 3 && !subido; intento++) {
      try {
        const resp = await fetch(`${AppData.API_URL}EjecucionTarea/SubirChunkArchivo`, {
          method: 'POST',
          headers: _buildApiHeaders(),
          body: formData
        });
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        const json = await resp.json();
        if (!json.Ok) throw new Error(json.Error || `Error en parte ${numeroParte}`);

        onProgress(json.Data.PartesRecibidas / totalPartes);

        if (json.Data.Completado) {
          finalResult = json.Data;
        }
        subido = true;
      } catch (err) {
        if (intento === 2) throw new Error(`Fallo al subir parte ${numeroParte} de ${totalPartes}: ${err.message}`);
      }
    }
  }

  if (!finalResult) {
    throw new Error('La carga finalizó pero el servidor no confirmó el ensamblado del archivo.');
  }

  return { FileId: finalResult.FileId, TempUrl: finalResult.TempUrl };
}

// ─────────────────────────────────────────────────────────────────────────────

/* import FileIcon from '../../../assets/images/file.svg'; */
const FileIconBase64 = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTcwcHgiIGhlaWdodD0iMTcwcHgiIHZpZXdCb3g9IjAgMCAyNC4wMCAyNC4wMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB0cmFuc2Zvcm09InJvdGF0ZSgwKSI+PGcgaWQ9IlNWR1JlcG9fYmdDYXJyaWVyIiBzdHJva2Utd2lkdGg9IjAiPjwvZz48ZyBpZD0iU1ZHUmVwb190cmFjZXJDYXJyaWVyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZT0iI0NDQ0NDQyIgc3Ryb2tlLXdpZHRoPSIwLjE5MiI+PC9nPjxnIGlkPSJTVkdSZXBvX2ljb25DYXJyaWVyIj4gPHBhdGggZD0iTTEyIDE4VjEyTTEyIDEyTDE0IDE0TTEyIDEyTDEwIDE0TTEzIDNIOC4yQzcuMDc5OSAzIDYuNTE5ODQgMyA2LjA5MjAyIDMuMjE3OTlDNS43MTU2OSAzLjQwOTczIDUuNDA5NzMgMy43MTU2OSA1LjIxNzk5IDQuMDkyMDJDNSA0LjUxOTg0IDUgNS4wNzk5IDUgNi4yVjE3LjhDNSAxOC45MjAxIDUgMTkuNDgwMiA1LjIxNzk5IDE5LjkwOEM1LjQwOTczIDIwLjI4NDMgNS43MTU2OSAyMC41OTAzIDYuMDkyMDIgMjAuNzgyQzYuNTE5ODQgMjEgNy4wNzk5IDIxIDguMiAyMUgxNS44QzE2LjkyMDEgMjEgMTcuNDgwMiAyMSAxNy45MDggMjAuNzgyQzE4LjI4NDMgMjAuNTkwMyAxOC41OTAzIDIwLjI4NDMgMTguNzgyIDE5LjkwOEMxOSAxOS40ODAyIDE5IDE4LjkyMDEgMTkgMTcuOFY5TTEzIDNMMTkgOU0xMyAzVjcuNEMxMyA3Ljk2MDA1IDEzIDguMjQwMDggMTMuMTA5IDguNDUzOTlDMTMuMjA0OSA4LjY0MjE1IDEzLjM1NzggOC43OTUxMyAxMy41NDYgOC44OTEwMUMxMy43NTk5IDkgMTQuMDM5OSA5IDE0LjYgOUgxOSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjAuMzYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPiA8L2c+PC9zdmc+'; 

export const fileInputType = 'fileInput';




export function FileInputRenderer(props) {
  const {
    disabled,
    errors = [],
    field,
    readonly,
    value = ''
  } = props;

  const {
    description,
    id,
    label,
    validate = {}
  } = field;

  const { required } = validate;
  const { formId } = useContext(FormContext);

  const [uploadProgress, setUploadProgress] = useState(null); // null | 0..1
  const [uploadError, setUploadError] = useState(null);

  const errorMessageId = errors.length === 0 ? undefined : `${prefixId(id, formId)}-error-message`;

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const MAX_FILE_SIZE = AppData.MAX_FILE_SIZE * 1024 * 1024;
  const CHUNK_THRESHOLD = (AppData.CHUNKED_UPLOAD_THRESHOLD_MB || 20) * 1024 * 1024;

  const onChange = async ({ target }) => {
    const file = target.files[0];
    setUploadError(null);

    // Verificar tamaño del archivo
    if (file.size > MAX_FILE_SIZE) {
      alert(`El archivo supera el tamaño máximo permitido de ${AppData.MAX_FILE_SIZE} MB`);
      target.value = '';
      return;
    }

    // Verificar tipo de archivo permitido (por tipo MIME y extensión)
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    const isValidType = AppData.ALLOWED_FILE_TYPES.includes(file.type);
    const isValidExtension = AppData.ALLOWED_FILE_TYPES.some(type => type.includes(fileExtension));
    
    if (!isValidType && !isValidExtension) {
      alert(`El tipo de archivo seleccionado (${file.type}) y extensión (${fileExtension}) no están permitidos.`);
      target.value = '';
      return;
    }

    const nombreArchivo = file.name;

    if (file.size > CHUNK_THRESHOLD && AppData.ENABLE_CHUNKED_UPLOAD !== false) {
      // ── Flujo chunked upload (archivos grandes) ───────────────────────────
      setUploadProgress(0);
      try {
        const result = await _uploadChunked(file, (p) => setUploadProgress(p));
        setUploadProgress(null);

        let objectFile = {
          name: nombreArchivo,
          fileId: result.FileId,
          tempUrl: result.TempUrl,
          isChunked: true
        };

        if (field.captureContentAsVariable && field.variableName) {
          objectFile.captureContent = true;
          objectFile.variableName = field.variableName;
        }
        if (field.captureContentAsVariableURL && field.variableNameURL) {
          objectFile.captureURL = true;
          objectFile.variableNameURL = field.variableNameURL;
        }

        props.onChange({ field, value: objectFile });
      } catch (err) {
        setUploadProgress(null);
        setUploadError(err.message || 'Error al subir el archivo');
        target.value = '';
      }
    } else {
      // ── Flujo base64 original (archivos pequeños ≤ umbral) ───────────────
      const base64Value = await convertBase64(file);

      let objectFile = { 'name': nombreArchivo, 'base64': base64Value };

      if (field.captureContentAsVariable && field.variableName) {
        objectFile.captureContent = true;
        objectFile.variableName = field.variableName;
        objectFile.content = base64Value.split(',')[1];
      }
      if (field.captureContentAsVariableURL && field.variableNameURL) {
        objectFile.captureURL = true;
        objectFile.variableNameURL = field.variableNameURL;
      }

      props.onChange({ field, value: objectFile });
    }
  };

  const onClick = () => {
    let newWindow = window.open('');
    newWindow.document.write(
      "<iframe width='100%' height='100%' src='" + value + "'></iframe>"
    );
  };

  if (disabled && value) {
    return html`
      <div class=${formFieldClasses(fileInputType, { errors, disabled })}>
        <${Label} id=${prefixId(id, formId)} label=${label} required=${required} />
        <a onClick=${onClick}><button type="button" class="fjs-button">View/Download</button></a>
        <${Description} description=${description} />
      </div>
    `;
  }

  return html`
    <div class=${formFieldClasses(fileInputType, { errors, disabled })}>
      <${Label} id=${prefixId(id, formId)} label=${label} required=${required} />
      <input
        class="fjs-input"
        disabled=${disabled || uploadProgress !== null}
        id=${prefixId(id, formId)}
        onInput=${onChange}
        type="file"
        accept=${AppData.ALLOWED_FILE_TYPES.join(',')} 
      />
      ${uploadProgress !== null && html`
        <div style="margin-top:6px;">
          <div style="font-size:12px;color:#555;margin-bottom:4px;">
            Subiendo archivo... ${Math.round(uploadProgress * 100)}%
          </div>
          <div style="background:#e0e0e0;border-radius:4px;height:8px;overflow:hidden;">
            <div style="background:#0078d4;height:100%;width:${Math.round(uploadProgress * 100)}%;transition:width 0.3s;"></div>
          </div>
        </div>
      `}
      ${uploadError && html`
        <div style="color:#d32f2f;font-size:12px;margin-top:4px;">${uploadError}</div>
      `}
      <${Description} description=${description} />
      <${Errors} errors=${errors} id=${errorMessageId} />
    </div>
  `;
}

FileInputRenderer.config = {
  ...Numberfield.config,
  type: fileInputType,
  label: 'Cargar archivo',
  iconUrl: FileIconBase64,
  propertiesPanelEntries: [
    'key',
    'label',
    'description',
    'disabled',
    'readonly',
    'captureContentAsVariable',
    'variableName',
    'captureContentAsVariableURL',
    'variableNameURL'
  ]
};

// helper functions
function formFieldClasses(type, { errors = [], disabled = false, readonly = false } = {}) {
  if (!type) {
    throw new Error('type required');
  }

  return classNames('fjs-form-field', `fjs-form-field-${type}`, {
    'fjs-has-errors': errors.length > 0,
    'fjs-disabled': disabled,
    'fjs-readonly': readonly
  });
}

function prefixId(id, formId) {
  if (formId) {
    return `fjs-form-${formId}-${id}`;
  }

  return `fjs-form-${id}`;
}
